'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
var SymbolTriangle = function SymbolTriangle(_ref) {
    var x = _ref.x,
        y = _ref.y,
        size = _ref.size,
        fill = _ref.fill;
    return _react2.default.createElement(
        'g',
        { transform: 'translate(' + x + ',' + y + ')' },
        _react2.default.createElement('path', {
            fill: fill,
            d: '\n                M' + size / 2 + ' 0\n                L' + size + ' ' + size + '\n                L0 ' + size + '\n                L' + size / 2 + ' 0\n            '
        })
    );
};

SymbolTriangle.propTypes = {
    x: _propTypes2.default.number.isRequired,
    y: _propTypes2.default.number.isRequired,
    size: _propTypes2.default.number.isRequired,
    fill: _propTypes2.default.string.isRequired
};

exports.default = SymbolTriangle;


//////////////////
// WEBPACK FOOTER
// ./~/@nivo/legends/lib/svg/symbols/SymbolTriangle.js
// module id = 400
// module chunks = 168707334958949